import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import BasicModal    from '@partials/basic-modal';
import ContentsModal from 'contents_modal';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class DraftComplete extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      check_modal  : false,
      check_target : '',
    };
  }
  // -------------------------------------------------------
  
  submit_check(mode) {
    let data = this.props.data;
    let detail = this.props.detail;
    
    let is_my_task = true;
    try {
      detail.draft_flow.map((d) => {
        if( d.order_no != detail.flow_no || d.user_id == data.userData.id ) return;
        
        is_my_task = false;
        
        if( d.guest_company != undefined ) this.setState({ check_target: d.guest_company.name });
        if( d.user != undefined ) this.setState({ check_target: d.user.name });
      });
    } catch(e) {}
    
    if( is_my_task == true ){
      this.submit.bind(this)(mode);
    } else {
      this.setState({ check_modal: true });
    }
    
  }
  // -------------------------------------------------------
  
  submit(mode) {
    let data = this.props.data;
    let detail = this.props.detail;
    
    let post_date = null;
    try { post_date = this.post_date.value; } catch(e) {}
    
    let is_remind = false;
    try { is_remind = this.is_remind.checked; } catch(e) {}
    
    Utils.request.bind(this)('/api/draft/complete', { draft_id: detail.id, project_id: data.project.id, post_date: post_date, is_master: (detail.my_authority == 99), mode: mode, is_remind: is_remind },
      function(res){
         alert('送信が完了しました！');
         this.props.change_ev.bind(this)(detail.id);
         this.setState({ check_modal: false });
         
         location.reload();
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  closeCheckModal() {
    this.setState({ check_modal: false });
  }
  // -------------------------------------------------------
  
  messageAlert(msg) {
    alert(String(msg));
  }
  // -------------------------------------------------------
  
  changeLatestAction() {
    let check = confirm('前の確認担当者の記載内容を復元します。\n現在編集中の情報は削除されますが適用してもよろしいですか？');
    if( check == false ) return;
    
    // 最終編集状態に戻す
    let edit = { draft_caption: {}, draft_media: {} };
    
    for( let id in this.props.detail.latest_edit_data ){
      let ary = this.props.detail.latest_edit_data[id];
      ary.map((d) => {
        try {
          if( d.media_id == null ){
            edit.draft_caption[d.contents_id] = { revise_message: d.revise_message, revise_movie_option: d.revise_movie_option, is_approval: d.is_approval };
            document.getElementById(('caption_'+ d.contents_id)).value = d.revise_message;
          } else {
            edit.draft_media[d.media_id] = { revise_message: d.revise_message, revise_movie_option: d.revise_movie_option, is_approval: d.is_approval };
            document.getElementById(('media_'+ d.contents_id +'_'+ d.media_id)).value = d.revise_message;
          }
        } catch(e) {}
      });
    }
    
    this.props.update_ev.bind(this)(edit);
  }
  // -------------------------------------------------------
  
  checkLatestData() {
    let detail = this.props.detail;
    let latest_edit = detail.latest_edit_data;
    
    let is_changed = false;
    try {
      for( let i in detail.draft_caption ){
        let p = detail.draft_caption[i];
        try {
          latest_edit[i].map((d) => {
            if( d.media_id == null && (d.is_approval != p.is_approval || d.revise_message != p.revise_message)) is_changed = true;
          });
        } catch(e){}
      }
      for( let i in detail.draft_media ){
        let ary = detail.draft_media[i];
        ary.map((p) => {
          try {
            latest_edit[i].map((d) => {
              if( d.media_id == p.id && (d.is_approval != p.is_approval || d.revise_message != p.revise_message)) is_changed = true;
            });
          } catch(e){}
        });
      }
    } catch(e) {}
    
    return is_changed;
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let detail = this.props.detail;
    let edit = this.props.edit;
    
    // パスワードモードには表示しない
    if( detail.is_send_action === false ) return null;
    
    let total_count = 0;
    let ng_count = 0;
    let complete_count = 0;
    let message_error_count = 0;
    
    try {
      
      // リポストリスト
      let repost = [];
      try { if( detail.repost != null ) repost = detail.repost.split(','); } catch(e) {}
      
      // キャプション数の取得
      for( let i in detail.draft_caption ){
        let d = detail.draft_caption[i];
        
        let product_type = null;
        detail.post_contents.map((p) => { if( p.id == d.contents_id ) product_type = p.media_type; });
        
        if( product_type == null || product_type == 'STORY' ){
          // None
        } else {
          total_count++;
          
          if( d.is_approval != null ) complete_count++;
          if( d.is_approval == 0 && (d.revise_message == null || d.revise_message == '') ) message_error_count++;
          if( d.is_approval == 0 ) ng_count++;
        }
      }
      
      // メディア数の取得
      for( let i in detail.draft_media ){
        detail.draft_media[i].map((d) => {
          if( repost.indexOf(String(d.contents_id)) >= 0 ) return;
          
          total_count++;
          if( d.is_approval != null ) complete_count++;
          if( d.is_approval == 0 && (d.revise_message == null || d.revise_message == '') ) message_error_count++;
          if( d.is_approval == 0 ) ng_count++;
        });
      }
    } catch(e) {}
    
    // ボタンボックスデザイン
    let box_design = (detail.my_authority == 99) ? 'multi' : 'single';
    if( detail.draft_flow.length == detail.flow_no ) box_design = 'last';
    
    // 確認結果を送信する場合 (エラー処理)
    let error_help = null;
    let error_msg = '';
    if( message_error_count      > 0 ){
      error_help = <p>修正指示で未入力の項目がございます</p>;
      error_msg = '修正指示で未入力の項目がございます';
    }
    if( complete_count < total_count ){
      error_help = <p>全ての項目にチェックを入れる必要がございます</p>;
      error_msg = '全ての項目にチェックを入れる必要がございます';
    }
    if( Object.keys(edit).length > 0 ) return null;
    
    // 投稿日指定
    let post_date_contents = null;
    let contents_height = 0;
    if( ng_count > 0 ){
      post_date_contents = (
        <div>
          <h5>下書き修正の提出日を設定したい場合は、以下に日付を入力してください</h5>
          <input type="date" className="text" ref={(input) => { this.post_date = input }} />
          
          <div className="is-remind-box">
            <div className="checkbox-frame">
              <input type="checkbox" id="is_remind" className="checkbox" ref={(input) => { this.is_remind = input }} defaultChecked />
              <label className="checkbox" htmlFor="is_remind">下書き提出日にDMでリマインドする（日付設定時のみ）</label>
            </div>
          </div>
        </div>
      );
      contents_height = 170;
    }
    
    // 送信メッセージ可変設定
    let send_message_button = (detail.is_guest == 1) ? '確認結果を送信する' : '次の確認担当者へ';
    let send_messgae_help = (detail.is_guest == 1) ? '下書きの確認結果を送信してもよろしいですか？' : '次の担当者に確認の依頼をします。よろしいですか？';
    
    let next_contents_help = (complete_count < total_count) ? <span className="alert">「内容OK」もしくは「修正依頼」が設定されていない項目がございます。<br />次に進めてもよろしいですか？</span> : null;
    
    // 最終データの存在確認
    let is_latest_data = false;
    try { if( Object.keys(this.props.detail.latest_edit_data).length > 0 ) is_latest_data = true; } catch(e) {}
    let is_changed = this.checkLatestData.bind(this)();
    
    // 確認結果の送信
    return (
      <div className={'draft-complete-box '+ box_design}>
        { (is_latest_data == true) &&
          <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>{(is_changed == true) ? '修正事項を最後の編集内容に戻す' : '未修正のため利用できません'}</Tooltip>}>
            { (is_changed == true)
              ? <div className="change-latest-action on" onClick={this.changeLatestAction.bind(this)}>
                  <i className="material-icons">reply</i>前の確認担当者の記載内容を復元する
                </div>
              : <div className="change-latest-action off">
                  <i className="material-icons">reply</i>前の確認担当者の記載内容を復元する
                </div>
            }
          </OverlayTrigger>
        }
        
        { (( error_help == null ) && box_design != 'last') &&
          <BasicModal
            html = {<div className="button draft-complete-button on"><i className="material-icons">task_alt</i>{send_message_button}</div>}
            width = {525}
            title = {send_messgae_help}
            contents = {next_contents_help}
            contents_height = {(next_contents_help != null) ? 50 : 0}
            buttons = {
              [{ id: 'yes', name: 'はい', event: this.submit_check.bind(this, 'next')}, { id: 'no', name: 'いいえ' }]
            }
          />
        }
        
        {(( error_help == null ) && detail.my_authority == 99) &&
          <BasicModal
            html = {<div className="button draft-complete-button on is-admin"><i className="material-icons">send</i>インフルエンサーに結果を送信する</div>}
            title = "下書きの確認結果をインフルエンサーに送信してもよろしいですか？"
            sub_title = {<span className="alert">※一度送信すると取り消しできません。ご注意ください</span>}
            width = {500}
            contents = {post_date_contents}
            contents_height = {contents_height}
            buttons = {
              [{ id: 'yes', name: 'はい', event: this.submit_check.bind(this, 'send-influencer')}, { id: 'no', name: 'いいえ' }]
            }
          />
        }
        
        { (this.state.check_modal == true) &&
          <ContentsModal
            view      = {this.state.check_modal}
            width     = {400}
            height    = {150}
            close_ev  = {this.closeCheckModal.bind(this)}
            html      = {(
              <div className="modal-item basic-modal next-check-modal">
                <h1><i className="material-icons">warning</i></h1>
                <h2 className="error">「{this.state.check_target}」さんが確認担当です。<br />代わりに次の担当に進めてもよろしいですか？</h2>
                
                <div className="yes-no">
                  <div className="button yes" onClick={this.submit.bind(this, 'next')}>はい</div>
                  <div className="button no" onClick={this.closeCheckModal.bind(this)}>いいえ</div>
                </div>
              </div>
            )}
          />
        }
        
        {(( error_help != null )) &&
          <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>{error_help}</Tooltip>}>
            <div className="button-box" onClick={this.messageAlert.bind(this, error_msg)}>
              <div className="button draft-complete-button off is-admin"><i className="material-icons">task_alt</i>{send_message_button}</div>
              <i className="material-icons warning">warning</i>
            </div>
          </OverlayTrigger>
        }
        {(( error_help != null ) && detail.my_authority == 99) &&
          <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>{error_help}</Tooltip>}>
            <div className="button-box" onClick={this.messageAlert.bind(this, error_msg)}>
              <div className="button draft-complete-button off is-admin"><i className="material-icons">send</i>インフルエンサーに結果を送信する</div>
              <i className="material-icons warning">warning</i>
            </div>
          </OverlayTrigger>
        }
      </div>
    );
    
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftComplete;